<template>
    <div id="library-reservation-punishments">
        <app-layout>
            <template v-slot:header>
                <AppHeader :title="$t('punished_students')"
                        :isNewButton="false"
                        @filter-div-status="datatable.filterStatus = $event">
                </AppHeader>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('punished_students')"
                              :isNewButton="false"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>

            <DatatableFilter
             v-show="datatable.filterStatus"
             :exportExcel="checkPermission('libraryreservationpunishment_excelexport')" @exportExcel="exportExcel"
             @filter="filter" @filterClear="filterClear">
                <b-row>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('student_number')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.student_number"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('date_between')" class="mb-0">
                            <v-date-picker v-model="datatable.queryParams.filter.date_between" is-range>
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 mr-1">
                                                <input :value="inputValue.start"
                                                       v-on="inputEvents.start"
                                                       :placeholder="$t('start_date')"
                                                       class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 ml-1">
                                                <input :value="inputValue.end"
                                                       v-on="inputEvents.end"
                                                       :placeholder="$t('end_date')"
                                                       class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                    </div>
                                </template>
                            </v-date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
            </DatatableFilter>

            <Datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                :lineNumbers="false"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            >
            </Datatable>

            <!-- Show Modal -->
            <CommonModal ref="showModal" size="lg">
                <template v-slot:CommonModalTitle>
                    {{ $t('library_reservation_punishment') }}
                </template>
                <template v-slot:CommonModalContent>
                    <div v-if="selectedPunishment">
                        <b-row>
                            <b-col md="6">
                                <p><strong>{{ $t('student_number') }}:</strong> {{ selectedPunishment.student_number }}</p>
                                <p><strong>{{ $t('name_surname') }}:</strong> {{ selectedPunishment.name }} {{ selectedPunishment.surname }}</p>
                                <p><strong>{{ $t('library_room_name') }}:</strong> {{ selectedPunishment.library_room_name }}</p>
                                <p><strong>{{ $t('library_chairs') }}:</strong> {{ selectedPunishment.library_chair_name }}</p>
                            </b-col>
                            <b-col md="6">
                                <p><strong>{{ $t('start_date') }}:</strong> {{ selectedPunishment.start_date }}</p>
                                <p><strong>{{ $t('end_date') }}:</strong> {{ selectedPunishment.end_date }}</p>
                            </b-col>
                        </b-row>
                    </div>
                </template>
            </CommonModal>
            <CommonModal ref="cancelModal" size="md" :onHideOnlyX="true" v-if="checkPermission('libraryreservationpunishment_cancel')">
                <template v-slot:CommonModalTitle>
                    {{ $t('cancel').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <ValidationObserver ref="formModalValidate">
                        <b-row>
                            <b-col cols="12">
                                <ValidationProvider name="reason" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('reason')">
                                        <b-form-textarea v-model="cancelForm.reason" no-resize rows="5" ></b-form-textarea>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </ValidationObserver>
                    <b-button
                        @click="cancel"
                        type="button"
                        :disabled="formLoading"
                        variant="primary"
                        class="btn-lg mr-2"
                    >
                        {{ $t("cancel") }}
                    </b-button>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
import AppHeader from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";
import Datatable from "@/components/datatable/Datatable.vue";
import DatatableFilter from "@/components/datatable/DatatableFilter.vue";
import CommonModal from "@/components/elements/CommonModal.vue";
import LibraryRoomSelectbox from "@/components/interactive-fields/LibraryRoomSelectbox.vue";
import LibraryReservationPunishmentService from "@/services/LibraryReservationPunishmentService";
import qs from "qs";

export default {
    name: "LibraryReservationPunishmentIndex",
    components: {
        AppLayout,
        AppHeader,
        HeaderMobile,
        Datatable,
        DatatableFilter,
        CommonModal,
        LibraryRoomSelectbox
    },
    metaInfo() {
        return {
            title: this.$t('punished_students')
        }
    },
    data() {
        return {
            selectedPunishment: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('show'),
                                class: 'ri-search-eye-line',
                                permission: 'libraryreservationpunishment_show',
                                callback: (row) => {
                                    this.showDetails(row);
                                }
                            },
                            {
                                text: this.$t('cancel'),
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "libraryreservation_changestatus",
                                callback: (row) => {
                                    this.showCancelForm(row.id);
                                }
                            }
                        ]
                    },
                    { label: this.$t('student_number'), field: 'student_number', sortable: false },
                    { label: this.$t('name'), field: 'name', sortable: false },
                    { label: this.$t('surname'), field: 'surname', sortable: false },
                    { label: this.$t('library_room_name'), field: 'library_room_name', sortable: false },
                    { label: this.$t('start_date'), field: 'start_date', sortable: false },
                    { label: this.$t('end_date'), field: 'end_date', sortable: false },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: true,
                queryParams: {
                    filter: {},
                    sort: '-id',
                    page: 1,
                    limit: 15
                },
            },
            cancelForm: {},
            formId: null,
            formLoading: false,
        }
    },
    mounted() {
        this.getRows();
    },
    methods: {
        getRows() {
            this.datatable.isLoading = true;
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            LibraryReservationPunishmentService.getAll(config)
                .then(response => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                })
                .catch(error => {
                    this.showErrors(error);
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onSortChange(params) {
            if (params.length > 0) {
                this.datatable.queryParams.sort = (params[0].type === 'desc' ? '-' : '') + params[0].field;
                this.getRows();
            }
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.getRows();
        },
        showDetails(row) {
            this.datatable.isLoading = true;
            LibraryReservationPunishmentService.get(row.id)
                .then(response => {
                    this.selectedPunishment = response.data.data;
                    this.$refs.showModal.$refs.commonModal.show();
                })
                .catch(error => {
                    this.showErrors(error);
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        exportExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            LibraryReservationPunishmentService.exportExcel(config).then(res => this._downloadFile(res, this.$t('punished_students') + '.xlsx')).catch(err => this.showErrors(err))
        },
        showCancelForm(id) {
            this.formClear()
            this.formId = id
            this.$refs.cancelModal.$refs.commonModal.show()
        },
        async cancel() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                this.formLoading = true;

                LibraryReservationPunishmentService.cancelReservation(this.formId, this.cancelForm)
                    .then((response) => {
                        this.formLoading=false;
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$refs.cancelModal.$refs.commonModal.hide()
                        this.getRows()
                        this.formClear()
                    })
                    .catch((error) => {
                        this.showErrors(error, this.$refs.formModalValidate)
                    })
            }
        },
        formClear() {
            this.formId = null
            this.cancelForm = {}
        },

    }
}
</script>
